// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddOrganization_container__Q9NXL {
  background-color: white;
  padding: 32px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 60%;
}

.AddOrganization_header__DoKW7 {
  display: flex;
  justify-content: space-between;
}

.AddOrganization_header__DoKW7 h3 {
  margin: 0;
}

.AddOrganization_header__DoKW7 span {
  cursor: pointer;
}

.AddOrganization_addOrgForm__eMqmZ {
  display: flex;
  flex-direction: column;
  gap: 32px;
  color: #676c7e;
  overflow-y: auto;
}

.AddOrganization_addOrgForm__eMqmZ::-webkit-scrollbar {
  width: 0;
  background: transparent;
}

.AddOrganization_addOrgForm__eMqmZ {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.AddOrganization_addOrgForm__eMqmZ::-webkit-scrollbar {
  display: none;
}

.AddOrganization_formElement__cnjA0 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid #ededed;
  border-radius: 12px;
  padding: 8px 16px;
  flex: 1 1;
}

.AddOrganization_formElement__cnjA0 label {
  font-size: 14px;
  color: rgba(27, 31, 59, 0.65);
}

.AddOrganization_addOrgForm__eMqmZ input,
.AddOrganization_addOrgForm__eMqmZ select {
  border: none;
  background-color: transparent;
  font-size: 1rem;
  color: #121b3f;
}

.AddOrganization_addOrgForm__eMqmZ select:focus,
.AddOrganization_addOrgForm__eMqmZ input:focus {
  outline: none;
}

.AddOrganization_saveBtn__6R36s {
  width: 100%;
  height: 44px;
  border-radius: 12px;
  padding: 0 16px;
  border: none;
  background-color: #3082f6;
  color: white;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.2s ease;
}

.AddOrganization_saveBtn__6R36s:disabled {
  background-color: #8cb6f1;
  cursor: not-allowed;
}

.AddOrganization_elements__5fJOd {
  display: flex;
  gap: 1rem;
}

.AddOrganization_formElement__cnjA0:has(input:disabled) {
  background-color: rgb(226, 224, 224);
}
`, "",{"version":3,"sources":["webpack://./src/components/modals/addOrganization/AddOrganization.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;EAEE,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".container {\r\n  background-color: white;\r\n  padding: 32px;\r\n  border-radius: 8px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 32px;\r\n  width: 60%;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.header h3 {\r\n  margin: 0;\r\n}\r\n\r\n.header span {\r\n  cursor: pointer;\r\n}\r\n\r\n.addOrgForm {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 32px;\r\n  color: #676c7e;\r\n  overflow-y: auto;\r\n}\r\n\r\n.addOrgForm::-webkit-scrollbar {\r\n  width: 0;\r\n  background: transparent;\r\n}\r\n\r\n.addOrgForm {\r\n  -ms-overflow-style: none;\r\n  scrollbar-width: none;\r\n}\r\n\r\n.addOrgForm::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.formElement {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  border: 1px solid #ededed;\r\n  border-radius: 12px;\r\n  padding: 8px 16px;\r\n  flex: 1;\r\n}\r\n\r\n.formElement label {\r\n  font-size: 14px;\r\n  color: rgba(27, 31, 59, 0.65);\r\n}\r\n\r\n.addOrgForm input,\r\n.addOrgForm select {\r\n  border: none;\r\n  background-color: transparent;\r\n  font-size: 1rem;\r\n  color: #121b3f;\r\n}\r\n\r\n.addOrgForm select:focus,\r\n.addOrgForm input:focus {\r\n  outline: none;\r\n}\r\n\r\n.saveBtn {\r\n  width: 100%;\r\n  height: 44px;\r\n  border-radius: 12px;\r\n  padding: 0 16px;\r\n  border: none;\r\n  background-color: #3082f6;\r\n  color: white;\r\n  cursor: pointer;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.saveBtn:disabled {\r\n  background-color: #8cb6f1;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.elements {\r\n  display: flex;\r\n  gap: 1rem;\r\n}\r\n\r\n.formElement:has(input:disabled) {\r\n  background-color: rgb(226, 224, 224);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AddOrganization_container__Q9NXL`,
	"header": `AddOrganization_header__DoKW7`,
	"addOrgForm": `AddOrganization_addOrgForm__eMqmZ`,
	"formElement": `AddOrganization_formElement__cnjA0`,
	"saveBtn": `AddOrganization_saveBtn__6R36s`,
	"elements": `AddOrganization_elements__5fJOd`
};
export default ___CSS_LOADER_EXPORT___;
